export enum AnnouncementInviteResponseEnum {
    NotResponded = 1,
    Interested = 2,
    InterestedAndApplied = 3,
    NotInterested = 4,
}
